<script lang="ts">
    import {route} from './Nav'
    import {jwt} from './Auth'
    import MainMenu from "./Component/MainMenu.svelte";
    import Login from "./Component/Login.svelte";
    import Users from "./Page/Users.svelte";
    import UserChats from "./Page/UserChats.svelte";
    import UserContacts from "./Page/UserContacts.svelte";
    import UserName from "./Page/UserName.svelte";
    import User from "./Page/User.svelte";
    import Contact from "./Page/Contact.svelte";
    import AddUser from "./Page/AddUser.svelte";
    import Graph from "./Page/Graph.svelte";
    import Downloading from "./Overlay/Downloading.svelte";
    import Modal from "./Overlay/Modal.svelte"
    import UserContactsSearch from "./Page/UserContactsSearch.svelte";
    import UserMessageSearch from "./Page/UserMessageSearch.svelte";
    import SearchNearAddTask from "./Page/SearchNearAddTask.svelte";
    import SearchNearTaskList from "./Page/SearchNearTaskList.svelte";
    import SearchNearTask from "./Page/SearchNearTask.svelte";
    import {overlay} from "./Store";
    import {modal} from "./Store";
    const pages = {Users, UserChats, UserContacts, UserName, User, Contact, AddUser, Graph, UserContactsSearch, UserMessageSearch, SearchNearAddTask, SearchNearTaskList, SearchNearTask}
    const overlays = {Downloading}
</script>
{#if $jwt}
    {#if $overlay!==null}
        <svelte:component this="{overlays[$overlay]}"/>
    {:else}
        <Modal show={$modal}>
            <MainMenu/>
            <svelte:component this="{pages[$route.id]}" params={$route.params}/>
        </Modal>
    {/if}
{:else}
    <Login/>
{/if}
